export function setData(state, data) {
    state.data = data;
}

export function setPaymentMethods(state, data) {
    state.paymentMethods = data;
}

export function setBanks(state, data) {
    state.banks = data;
}



// WEBPACK FOOTER //
// ./src/reports-aggrid/modules/cash-receipts-app/mutations.js